/** function for generate errors from BE for export charging sessions */
export const exportChargingSessionsApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  TEMPLATE_NOT_FOUND: 'emobility.api-errors.temple-not-found',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  INSTALLATION_NOT_FOUND: 'emobility.api-errors.installation-no-found',
  IMAGE_NOT_FOUND: 'emobility.api-errors.image-not-found',
  INTEGRATION_FAILED: 'emobility.api-errors.integration-failed',
  REIMBURSEMENT_NOT_ENABLED: 'emobility.api-errors.reimbursement-not-enabled',
}
